const Login = () => import(/* webpackChunkName: "Main" */ 'RootDir/modules/Authorization/Login.vue');

export default [
  {
    path: 'login',
    name: 'login',
    component: Login,
  },
];
